var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Right"},[_c('div',{staticStyle:{"border":"none"},on:{"click":_vm.backTop}},[_c('img',{attrs:{"src":require("../assets/images/27.jpg"),"alt":""}}),_c('p',[_vm._v("回到顶部")])])])}
var staticRenderFns = []

export { render, staticRenderFns }